export const version = "solidity/5.6.0";
